import { userStore, res } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
export default {
    async login(id: string, password: string): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/login",
                {
                    id: id,
                    pw: password,
                },
                { withCredentials: false },
            );

            const user = userStore();
            user.setToken(response.data.token);

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async accept(): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/login/confirm", null, { withCredentials: false });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.error(error);
        }

        return res;
    },
    async getDeptList(): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/dept", null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getPositionList(): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/position", null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getTypeList(): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/type", null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getDetailTypeList(): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/detail/type", null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getNationList(): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/nations", null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async saveNaion(idx: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/nations/" + idx, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async saveNaionAll(state: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/nations/all/" + state, null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async getAutoMonitoring(): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/auto/monitoring", null, {
                withCredentials: false,
            });

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async saveAutoMonitoring(twitter: number, image: number): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/auto/monitoring/update",
                {
                    twitter,
                    image,
                },
                {
                    withCredentials: false,
                },
            );

            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
